import { Search, Settings } from "lucide-react";
import { useState, useEffect } from "react";
import "../assets/style/modal-print.css";
import { TagihanItem, TagihanLoketItem } from "../model/Hublang";
import { fetchGetTagihanLoket, fetchGetTagihanLoketNsb } from "../controller/dashboard/Loket";

export default function PenagihanDepan() {
    type SortKey = 'no' | 'nama' | null;
    type SortDirection = 'asc' | 'desc';

    const [sortKey, setSortKey] = useState<SortKey>(null);
    const [sortDirection, setSortDirection] = useState<SortDirection>('asc');

    const [selectedTagihanLoket, setSelectedTagihanLoket] = useState<TagihanLoketItem | null>(null);

    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10); // bisa default 
    const [statusFilter, setStatusFilter] = useState<TagihanLoketItem>({
        no : 0,  
        nama: 'all',
        nsb: 'all',
        kecamatan: 'all',
        alamat : 'all',
        desa: 'all',
        klasf: 'all',
        pelanggan: 'all',
        status: 'all',
        tunggakan: 'all',
        total: 'all'
    });

    const [statusLength, setStatusLength] = useState('10');
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [photoMeterData, setPhotoMeterData] = useState<TagihanLoketItem[]>([]);

    const filteredPhotoMeters = photoMeterData.filter(plg => {
        const matchesSearch =plg.nama.toLowerCase().includes(searchTerm.toLowerCase()) ||
        plg.nama.includes(searchTerm) ||
        plg.nsb.includes(searchTerm);
        return matchesSearch; // && matchesStatus;
    });
 
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentPhotoMeters = filteredPhotoMeters.slice(indexOfFirstItem, indexOfLastItem);
    let totalPages = itemsPerPage > 0 ? Math.ceil(filteredPhotoMeters.length / itemsPerPage) : 0;
    const pageNumbers = totalPages > 0 ? Array.from({ length: totalPages }, (_, i) => i + 1) : [];

    const initDataPhotoMeter = async () => { 
        setLoading(true);
        try {
            const res = await fetchGetTagihanLoket('sapto');
            if (res.status === 200 && Array.isArray(res.data)) {

                const today = new Date();
                today.setHours(0, 0, 0, 0);

                const processedData = res.data.map((item: any) => ({
                    no          : 0,
                    nama        : item.NAMA?.trim() || "Tidak ada data",
                    nsb         : item.NOSAMB || "Tidak ada data",
                    alamat      : item.ALAMAT || "Tidak ada data",
                    kecamatan   : item.KECAMATAN || "Tidak ada data",
                    desa        : item.DESA || "Tidak ada data",
                    klasf       : item.KLAS || "Tidak ada data",
                    pelanggan   : item.PELANGGAN || "Tidak ada data",
                    status      : item.STATUS || "Tidak ada data",
                    tunggakan   : item.TUNGGAKAN || "Tidak ada data",
                    total       : item.TOTAL || "Tidak ada data",
                }));

                const sortedData = processedData;
                setPhotoMeterData(sortedData);
            } else {
                console.error("Invalid response data:", res.data);
                setPhotoMeterData([]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            setPhotoMeterData([]);
        } finally {
            setLoading(false);
        }
    };

    const handleShowDetail = (tl : TagihanLoketItem) => {
        setSelectedTagihanLoket(tl);
        setShowDetailModal(true);
    }
    
    const handleShowDetailClose = () => {
      setSelectedTagihanLoket(null);
      setShowDetailModal(true);
    }
    
    const RenderTablePhotoMeterPelanggan = ({ filteredData, onOpenDetail }: { 
        filteredData: TagihanLoketItem[] | null; 
        onOpenDetail : (employee: TagihanLoketItem) => void;
    }) => {

        return(
            <>
                {
                    filteredData && filteredData.length > 0 ? (
                        filteredData.map((plg, idx) => (
                        <tr key={idx} className="bg-gray-50 hover:bg-gray-200 transition-colors">
                            <td className="px-2 py-4 whitespace-nowrap">
                                {idx + 1}
                            </td>
                            <td className="px-5 py-4 whitespace-nowrap text-sm text-gray-900">
                                <div>
                                    {plg.nama}
                                </div>
                                <div style={{ fontSize: '0.55rem' }}>
                                    <span style={{ color : "red" }}>NSB {plg.nsb}</span> | {plg.alamat.substring(0, 50)}
                                </div>
                            </td>
            
                            <td className="px-1 py-4 whitespace-nowrap text-sm text-gray-900">
                                <button onClick={() => { onOpenDetail(plg) }} className="flex items-center justify-center p-2 text-white bg-blue-600 rounded-lg hover:bg-blue-700"
                                ><Settings /></button>
                            </td>
                        </tr>
                        ))
                    ) : (
                        <tr>
                        <td colSpan={18} className="text-center py-4 text-gray-500">
                            Tidak ada data
                        </td>
                        </tr>
                    )
                }
            </>
        );
    };
    
    const DetailPreviewModal = ({ pelangganTLDetail, stateShowModal } : { 
        pelangganTLDetail: TagihanLoketItem | null; 
        stateShowModal: (show: boolean) => void | false;
        onClose: () => void;
    }) => {
        const [data, setData] = useState<any>({ data: [] });
        const [loadingData, setLoadingData] = useState<boolean>(false);
    
        useEffect(() => {
            const fetchData = async () => {
                setLoadingData(true);
                const result = await fetchGetTagihanLoketNsb(pelangganTLDetail?.nsb || '', 'sapto');
                
                setData(result);
                setLoadingData(false);
            };
            fetchData();
        }, [pelangganTLDetail]);        
    
        const sortedData = data.data.slice().sort((a : any, b : any) => {
            if (a.TAHUN !== b.TAHUN) return b.TAHUN - a.TAHUN;
            return b.BULAN - a.BULAN;
        });
    
        return(
            <>
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-50">
                <div className="bg-white mx-4 p-4 w-full max-w-9xl overflow-hidden">
                    <div>
                        <h3 className="text-md font-semibold text-center text-gray-800">{pelangganTLDetail?.nama} </h3>
                    </div>

                    <div className="flex items-center justify-between mb-6">
                        <div>
                            <div className="text-xs font-semibold text-gray-500">Alamat : {pelangganTLDetail?.alamat}</div>
                            <div className="text-xs font-semibold text-gray-500">Pelanggan : {pelangganTLDetail?.status}</div>
                            <div className="text-xs font-semibold text-gray-500">Klasf : {pelangganTLDetail?.klasf}</div>
                        </div>
                    </div>
                
                    <div className="max-h-[70vh] overflow-y-auto">
                        <table className="min-w-full table-auto max-w-screen-sm divide-y divide-gray-200">
                            <thead className="bg-gray-50">
                                <tr>
                                    <th className="px-2 py-2 sm:px-6 sm:py-3 text-left text-[10px] sm:text-xs font-medium text-gray-500 uppercase">PERIODE</th>
                                    <th className="px-2 py-2 sm:px-6 sm:py-3 text-left text-[10px] sm:text-xs font-medium text-gray-500 uppercase">KLASF</th>
                                    <th className="px-2 py-2 sm:px-6 sm:py-3 text-left text-[10px] sm:text-xs font-medium text-gray-500 uppercase">DENDA</th>
                                    <th className="px-2 py-2 sm:px-6 sm:py-3 text-left text-[10px] sm:text-xs font-medium text-gray-500 uppercase">TOTAL</th>
                                </tr>
                            </thead>
                            <tbody>
                    { sortedData && sortedData.length > 0 ? (
                                <>
                                  {sortedData.map((tagihan: any, idx: number) => (
                                      <tr key={idx} className="hover:bg-gray-100 transition-colors">
                                        <td className="px-2 py-2 text-[11px] sm:text-sm whitespace-nowrap">{tagihan.periode}</td>
                                        <td className="px-2 py-2 sm:px-6 sm:py-4 whitespace-nowrap text-xs sm:text-sm text-gray-900">{tagihan.KLAS}</td>
                                        <td className="px-2 py-2 sm:px-6 sm:py-4 whitespace-nowrap text-xs sm:text-sm text-gray-900">{parseInt(tagihan.DENDA).toLocaleString('id-ID', { style: 'currency', currency: 'IDR' })}</td>
                                        <td className="px-2 py-2 sm:px-6 sm:py-4 whitespace-nowrap text-xs sm:text-sm text-gray-900">{parseInt(tagihan.TOTAL).toLocaleString('id-ID', { style: 'currency', currency: 'IDR' })}</td>
                                      </tr>
                                  ))}
    
                                  {/* 🔹 Tambahkan baris total */}
                                  <tr className="bg-gray-100 font-semibold text-gray-900">
                                      <td colSpan={2} className="px-2 py-2 sm:px-6 sm:py-4 whitespace-nowrap text-xs sm:text-sm text-gray-900px-2 py-2 sm:px-6 sm:py-4 whitespace-nowrap text-xs sm:text-sm text-gray-900 text-center">
                                      TOTAL
                                      </td>
                                      <td className="px-2 py-2 sm:px-6 sm:py-4 whitespace-nowrap text-xs sm:text-sm text-gray-900px-2 py-2 sm:px-6 sm:py-4 whitespace-nowrap text-xs sm:text-sm text-gray-900">
                                          {sortedData.reduce((sum: number, t: any) => sum + (Number(t.DENDA) || 0), 0).toLocaleString('id-ID', { style: 'currency', currency: 'IDR' })}
                                      </td>
                                      <td className="px-2 py-2 sm:px-6 sm:py-4 whitespace-nowrap text-xs sm:text-sm text-gray-900px-2 py-2 sm:px-6 sm:py-4 whitespace-nowrap text-xs sm:text-sm text-gray-900">
                                          {sortedData.reduce((sum: number, t: any) => sum + (Number(t.TOTAL) || 0), 0).toLocaleString('id-ID', { style: 'currency', currency: 'IDR' })}
                                      </td>
                                  </tr>
                                </>
                                ) : (
                                <tr>
                                    { loadingData ?  
                                        <td colSpan={15} className="text-center py-4 text-gray-500">
                                            Sedang Loading . . . 
                                        </td>
                                        :
                                        <td colSpan={15} className="text-center py-4 text-gray-500">
                                            Tidak ada data tagihan 
                                        </td>
                                    }
                                </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    <div className="flex justify-center mt-4">
                        <button
                            onClick={() => stateShowModal(false)}
                            className="text-md font-semibold text-gray-800"
                        >
                            Tutup
                        </button>
                    </div>
                </div>
            </div>
            </>
        );
    }

    useEffect(() => {
      initDataPhotoMeter();
      setItemsPerPage(Number(statusLength === 'all' ? photoMeterData.length : statusLength))
    }, []);

    return (
      <>
        {/* Controls 2*/}
        <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-4 md:space-y-0">
            {/* <div className="flex space-x-3"> */}
              {/* Search */}
              <div className="relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                <input
                  type="text"
                  placeholder="Cari nama atau NSB"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent w-full md:w-64"
                />
              </div>
            {/* </div> */}
          </div>
        </div>

        {/* Employee Table */}
        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
          <div className="overflow-x-auto">
              <table className="table-auto min-w-full max-w-screen-lg divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    NO
                  </th>
                  <th className="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    DETAIL
                  </th>
                  <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                  {
                    loading? 
                    <>
                      <tr>
                        <td colSpan={18} className="text-center py-4 text-gray-500">
                          Sedang Loading . . .
                        </td>
                      </tr>
                    </>
                    :
                    <>
                      <RenderTablePhotoMeterPelanggan filteredData={currentPhotoMeters} onOpenDetail={handleShowDetail} />
                    </>
                  }
              </tbody>
            </table>
          </div>
        </div>
  
        {showDetailModal && <DetailPreviewModal pelangganTLDetail={selectedTagihanLoket} stateShowModal={setShowDetailModal} onClose={handleShowDetailClose}/>}
      </>
    )
};